import { type ExtractPropTypes, computed } from 'vue';

export const withDisabledProps = {
  /**
   * Element zablokowany
   */
  disabled: {
    type: Boolean,
    default: false
  }
};

/**
 * Zwraca klasę disabled
 *
 * @export
 * @param {*} [props={}]
 * @returns
 */
export const useDisabledProps = (prefix: string, props: ExtractPropTypes<typeof withDisabledProps>) => {
  return computed(() => {
    return props.disabled === true ? `${prefix}--disabled` : undefined;
  });
};

/**
 * Konfiguracja dla storybooka
 */
export const storiesDisabledArgs = {
  args: {
    disabled: false
  },

  argTypes: {
    disabled: {
      control: { type: 'boolean' }
    }
  }
};
